import PropTypes from 'prop-types';
import React, { createContext, Component } from 'react';
import { BrowseCourseCard } from '../browse-course-card/browse-course-card.react-component';
import { BrowseCourseProductCard } from '../browse-course-card/browse-course-product-card.react-component';
import { AsyncCourseStaticPriceText } from '../price-text/async-course-static-price-text.react-component';
export const AsyncPriceCourseCardContext = /*#__PURE__*/createContext({
  useCourseProductCard: false,
  hideCourseDescription: false
});
export class AsyncPriceCourseCard extends Component {
  constructor(...args) {
    super(...args);
    this.renderWithAsyncCourseStaticPrice = (StaticPriceTextComponent, priceTextProps) => {
      // AsyncCourseStaticPriceText derives these props internally from `course`, so
      // pluck them lest they overwrite AsyncCourseStaticPriceText.
      const {
        /* eslint-disable @typescript-eslint/no-unused-vars */
        listPrice,
        discountPrice,
        listPriceString,
        discountPriceString,
        /* eslint-enable @typescript-eslint/no-unused-vars */
        ...additionalPriceTextProps
      } = priceTextProps;
      return /*#__PURE__*/React.createElement(AsyncCourseStaticPriceText, Object.assign({
        courses: [this.props.course]
      }, additionalPriceTextProps));
    };
  }
  render() {
    var _this$context;
    if ((_this$context = this.context) !== null && _this$context !== void 0 && _this$context.useCourseProductCard) {
      var _this$context2;
      return /*#__PURE__*/React.createElement(BrowseCourseProductCard, Object.assign({}, this.props, {
        isAsyncStaticPrice: true,
        showDescription: !((_this$context2 = this.context) !== null && _this$context2 !== void 0 && _this$context2.hideCourseDescription)
      }));
    } else {
      return /*#__PURE__*/React.createElement(BrowseCourseCard, Object.assign({
        renderPriceText: this.renderWithAsyncCourseStaticPrice
      }, this.props));
    }
  }
}
AsyncPriceCourseCard.propTypes = {
  course: PropTypes.object.isRequired
};
AsyncPriceCourseCard.contextType = AsyncPriceCourseCardContext;
//# sourceMappingURL=async-price-course-card.react-component.js.map